import React from "react";
import { useNavigate } from "react-router-dom";

const Logout: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");
    localStorage.removeItem("password");
    localStorage.removeItem("registration_email");
    navigate("/login");
  };

  return (
    <button
      type="button"
      onClick={handleLogout}
      className="text-lg font-semibold font-body text-gray-600 hover:text-ink transition-colors duration-200"
      aria-label="Log out"
    >
      Logout
    </button>
  );
};

export default Logout;